import { useState, useEffect, useCallback } from "react";
import { DorkHistoryItem, GeneratedDork, DorkGenerationOptions } from "@/types/dork";

const HISTORY_KEY = "dork-history";
const MAX_HISTORY_ITEMS = 20;

export function useDorkHistory() {
  const [history, setHistory] = useState<DorkHistoryItem[]>([]);

  useEffect(() => {
    const stored = localStorage.getItem(HISTORY_KEY);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setHistory(parsed);
      } catch (e) {
        console.error("Failed to parse history:", e);
      }
    }
  }, []);

  const addToHistory = useCallback((
    keyword: string,
    dorks: GeneratedDork[],
    options: DorkGenerationOptions
  ) => {
    const newItem: DorkHistoryItem = {
      id: `history-${Date.now()}`,
      keyword,
      dorks,
      timestamp: new Date(),
      options,
    };

    setHistory((prev) => {
      const updated = [newItem, ...prev.filter((h) => h.keyword !== keyword)].slice(0, MAX_HISTORY_ITEMS);
      localStorage.setItem(HISTORY_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  const clearHistory = useCallback(() => {
    setHistory([]);
    localStorage.removeItem(HISTORY_KEY);
  }, []);

  return { history, addToHistory, clearHistory };
}
